module.exports = __webpack_public_path__ + "img/1118537855.fc5d467a.png";